import React from "react";

function DisabledInputWithRemove({ value, onRemove }) {
	return (
		<div className="disabled-input-with-remove">
			<input type="text" disabled value={value} />
			{value && (
				<button
					onClick={onRemove}
					className="remove-button"
					aria-label="Remove"
				>
					&times;
				</button>
			)}
		</div>
	);
}

export default DisabledInputWithRemove;
